export const authType = {
	login: {
		dataAction: 'SIGN_IN',
		dataLoading: 'SIGN_IN_LOADING',
		dataError: 'SIGN_IN_ERROR',
	},
	sendOtp: {
		dataAction: 'SEND_OTP',
		dataLoading: 'SEND_OTP_LOADING',
		dataError: 'SEND_OTP_ERROR',
	},
};

export const agentType = {
	getAll: {
		dataAction: 'allAgents',
		dataLoading: 'allAgentsLoading',
		dataError: 'allAgentsError',
	},
	getProfile: {
		dataAction: 'agentProfile',
		dataLoading: 'agentProfileLoading',
		dataError: 'agentProfileError',
	},
	create: {
		dataAction: 'createAgent',
		dataLoading: 'createAgentLoading',
		dataError: 'createAgentError',
	},
	update: {
		dataAction: 'updateAgent',
		dataLoading: 'updateAgentLoading',
		dataError: 'updateAgentError',
	},
	getPartyGuid: {
		dataAction: 'partyguid',
		dataLoading: 'partyguidLoading',
		dataError: 'partyguidError',
	},
	getElectionGuid: {
		dataAction: 'electionguid',
		dataLoading: 'electionguidLoading',
		dataError: 'electionguidError',
	},
	verifyVolunteer: {
		dataAction: 'verifyVolunteer',
		dataLoading: 'verifyVolunteerLoading',
		dataError: 'verifyVolunteerError',
	},
	volunteerStatus: {
		dataAction: 'volunteerStatus',
		dataLoading: 'volunteerStatusLoading',
		dataError: 'volunteerStatusError',
	},
	logConsent: {
		dataAction: 'logConsent',
		dataLoading: 'logConsentLoading',
		dataError: 'logConsentError',
	},
};

export const kycType = {
	enrolFace: {
		dataAction: 'kycEnrolFace',
		dataLoading: 'kycEnrolFace_Loading',
		dataError: 'kycEnrolFace_Error',
	},
	checkId: {
		dataAction: 'kycCheckId',
		dataLoading: 'kycCheckId_Loading',
		dataError: 'kycCheckId_Error',
	},
	matchFace: {
		dataAction: 'kycMatchFace',
		dataLoading: 'kycMatchFace_Loading',
		dataError: 'kycMatchFace_Error',
	},
};

export const resultType = {
	getAllApproved: {
		dataAction: 'getAllApprovedResults',
		dataLoading: 'getAllApprovedResults_Loading',
		dataError: 'getAllApprovedResults_Error',
	},
	getAllRejected: {
		dataAction: 'getAllRejectedResults',
		dataLoading: 'getAllRejectedResults_Loading',
		dataError: 'getAllRejectedResults_Error',
	},
	getAllUnapproved: {
		dataAction: 'getAllUnApprovedResults',
		dataLoading: 'getAllUnApprovedResults_Loading',
		dataError: 'getAllUnApprovedResults_Error',
	},
	getById: {
		dataAction: 'getResultById',
		dataLoading: 'getResultById_Loading',
		dataError: 'getResultById_Error',
	},
	updateResultData: {
		dataAction: 'updateResultData',
		dataLoading: 'updateResultData_Loading',
		dataError: 'updateResultData_Error',
	},
	updatePartyResultData: {
		dataAction: 'updatePartyResultData',
		dataLoading: 'updatePartyResultData_Loading',
		dataError: 'updatePartyResultData_Error',
	},
	updateStatus: {
		dataAction: 'updateResultStatus',
		dataLoading: 'updateResultStatus_Loading',
		dataError: 'updateResultStatus_Error',
	},
	uploadResultData: {
		dataAction: 'uploadResultData',
		dataLoading: 'uploadResultData_Loading',
		dataError: 'uploadResultData_Error',
	},
};

export const otherType = {
	menuOpen: {
		dataAction: 'menuOpen',
		dataLoading: 'menuOpen_Loading',
		dataError: 'menuOpen_Error',
	},
	subMenuOpen: {
		dataAction: 'subMenuOpen',
		dataLoading: 'subMenuOpen_Loading',
		dataError: 'subMenuOpen_Error',
	},
	pageSection: {
		dataAction: 'pageSection',
		dataLoading: 'pageSectionLoading',
		dataError: 'pageSectionError',
	},
};

export const electionType = {
	electionCycle: {
		dataAction: 'getAllElectionCycles',
		dataLoading: 'getAllElectionCycles_Loading',
		dataError: 'getAllElectionCycles_Error',
	},
	electionCategories: {
		dataAction: 'getAllElectionCategory',
		dataLoading: 'getAllElectionCategory_Loading',
		dataError: 'getAllElectionCategory_Error',
	},
	election: {
		dataAction: 'getAllElections',
		dataLoading: 'getAllElections_Loading',
		dataError: 'getAllElections_Error',
	},
	electionByName: {
		dataAction: 'electionByName',
		dataLoading: 'electionByName_Loading',
		dataError: 'electionByName_Error',
	},
	getAllApproved: {
		dataAction: 'getAllApprovedResults',
		dataLoading: 'getAllApprovedResults_Loading',
		dataError: 'getAllApprovedResults_Error',
	},
	primarySearch: {
		dataAction: 'primarySearchResults',
		dataLoading: 'primarySearchResults_Loading',
		dataError: 'primarySearchResults_Error',
	},
	tableSearch: {
		dataAction: 'tableSearchResults',
		dataLoading: 'tableSearchResults_Loading',
		dataError: 'tableSearchResults_Error',
	},
	getAllPoliticalParties: {
		dataAction: 'getAllPoliticalParties',
		dataLoading: 'getAllPoliticalParties_Loading',
		dataError: 'getAllPoliticalParties_Error',
	},
	getAllActiveElections: {
		dataAction: 'getAllActiveElections',
		dataLoading: 'getAllActiveElections_Loading',
		dataError: 'getAllActiveElections_Error',
	},
	getAllElectionApplicationLinks: {
		dataAction: 'getAllElectionApplicationLinks',
		dataLoading: 'getAllElectionApplicationLinks_Loading',
		dataError: 'getAllElectionApplicationLinks_Error',
	},
	getLegalDocuments: {
		dataAction: 'getLegalDocuments',
		dataLoading: 'getLegalDocuments_Loading',
		dataError: 'getLegalDocuments_Error',
	},
};

export const locationType = {
	state: {
		dataAction: 'GET_STATE',
		dataLoading: 'GET_STATE_LOADING',
		dataError: 'GET_STATE_ERROR',
	},
	zone: {
		dataAction: 'GET_ZONE',
		dataLoading: 'GET_ZONE_LOADING',
		dataError: 'GET_ZONE_ERROR',
	},
	geozone: {
		dataAction: 'GET_GEO_ZONE',
		dataLoading: 'GET_GEO_ZONE_LOADING',
		dataError: 'GET_GEO_ZONE_ERROR',
	},
	pollingUnit: {
		dataAction: 'GET_POOLING_UNIT',
		dataLoading: 'GET_POOLING_UNIT_LOADING',
		dataError: 'GET_POOLING_UNIT_ERROR',
	},
	pollingUnitById: {
		dataAction: 'POOLING_UNIT_BY_ID',
		dataLoading: 'POOLING_UNIT_BY_ID_LOADING',
		dataError: 'POOLING_UNIT_BY_ID_ERROR',
	},
	pollingUnitsInWard: {
		dataAction: 'GET_POOLING_UNITS_IN_WARD',
		dataLoading: 'GET_POOLING_UNITS_IN_WARD_LOADING',
		dataError: 'GET_POOLING_UNITS_IN_WARD_ERROR',
	},
	ward: {
		dataAction: 'GET_WARD',
		dataLoading: 'GET_WARD_LOADING',
		dataError: 'GET_WARD_ERROR',
	},
	wardsInLGA: {
		dataAction: 'GET_WARDS_IN_LGA',
		dataLoading: 'GET_WARDS_IN_LGA_LOADING',
		dataError: 'GET_WARDS_IN_LGA_ERROR',
	},
	wardsInConsistuency: {
		dataAction: 'GET_WARDS_IN_CONSISTUENCY',
		dataLoading: 'GET_WARDS_IN_CONSISTUENCY_LOADING',
		dataError: 'GET_WARDS_IN_CONSISTUENCY_ERROR',
	},
	lga: {
		dataAction: 'GET_LGA',
		dataLoading: 'GET_LGA_LOADING',
		dataError: 'GET_LGA_ERROR',
	},
	lgasInState: {
		dataAction: 'GET_LGAS_IN_STATE',
		dataLoading: 'GET_LGAS_IN_STATE_LOADING',
		dataError: 'GET_LGAS_IN_STATE_ERROR',
	},
	lgasInConsistuency: {
		dataAction: 'LGAS_IN_CONSISTUENCY',
		dataLoading: 'LGAS_IN_CONSISTUENCY_LOADING',
		dataError: 'LGAS_IN_CONSISTUENCY_ERROR',
	},
	party: {
		dataAction: 'GET_PARTY',
		dataLoading: 'GET_PARTY_LOADING',
		dataError: 'GET_PARTY_ERROR',
	},
	constituencyById: {
		dataAction: 'getConstituencyById',
		dataLoading: 'getConstituencyByIdLoading',
		dataError: 'getConstituencyByIdError',
	},
};
